/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { ImageBlock } from "src/classes/block/block-types";
import { Plate } from "src/classes/plate/Plate";
import { HiddenInput, StyledImagePicker } from "src/components/Block/BlockTypes/ImageBlock/styles";

interface Props {
  block: ImageBlock;
  plate: Plate;
  editable: boolean;
}
export function ImagePicker({ block, editable, plate }: Props) {
  return (
    <>
      <StyledImagePicker htmlFor={`file-upload-${block.snapshot.id}`} className="custom-file-upload">
        <div>Click to select an image</div>
        <div
          style={{
            fontSize: "11px",
            paddingTop: "3px",
          }}
        >
          (You can also drag and drop)
        </div>
      </StyledImagePicker>
      <HiddenInput
        disabled={!editable}
        type="file"
        accept="image/*"
        multiple={false}
        onChange={(e) => block.addFile((e.target.files as FileList)[0], plate.dimensions)}
        id={`file-upload-${block.snapshot.id}`}
      />
    </>
  );
}
